import React, { Suspense } from "react";

const HiringFunnel = React.lazy(() => import("@/pages/hiring-funnel"));

export default function HiringFunnelContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <HiringFunnel />
    </Suspense>
  );
}
